export const AVAILABLE_OFFERS = {
  score: '2000.00',
  offers: [
    {
      id: '58cmock6-4b63-4015-8ad5-8e7a17mock79',
      repayment_frequency: {
        type: 'monthly',
        minimum_installments: '6',
        maximum_installments: '6',
      },
      minimum_amount: '1800.01',
    },
    {
      id: '3mockace-7de8-4d3f-87bd-2bdmock35abf',
      repayment_frequency: {
        type: 'monthly',
        minimum_installments: '12',
        maximum_installments: '12',
      },
      minimum_amount: '1800.01',
    },
  ],
};
